import _ from "underscore";
import { useChatCurrentUser } from "../contexts/chat-current-user-context";
import { getETUserIDFromChatKitUser } from "../utils/utils";
import { useETCachedUsersByIds } from "../contexts/et-user-context";
import { useChatDependencyContext } from "../contexts/chat-dependency-context";

// compose multiple contexts to get et user id list, pass to cached user resolver to resolve
const useAllETUsersByIdsResolver = () => {
  const { oid, userId } = useChatDependencyContext();
  const { currentChatUser } = useChatCurrentUser();
  const all_user_ids = currentChatUser.users
    ? currentChatUser.users.flatMap(user => {
        if (user.id === "super") return [];
        const user_id = getETUserIDFromChatKitUser(oid, user.id) || [];

        return user_id;
      })
    : [];

  const { allUsersById, idsLoading } = useETCachedUsersByIds(all_user_ids);
  const allUsersWithoutCurrentUser = _.omit(allUsersById, userId);

  return { allUsersById, idsLoading, allUsersWithoutCurrentUser };
};

export default useAllETUsersByIdsResolver;
